import { observer } from 'mobx-react'
import React from 'react'
import Table from '../../Components/Table'
import ReportCollection from '../../State/Collections/ReportCollection'
import StaffCollection from '../../State/Collections/StaffCollection'
import SessionStore from '../../State/SessionStore'
import LoadingSpinner from '../../Components/LoadingSpinner'
import RenderOnQueries from '../Layout/RenderOnQueries'
import FetchStore from '../../Queries/FetchStore'
import UpdateReportModal from '../../Components/UpdateReportModal'
import { dateStringLookup } from '../../Components/Filters'
import { trpc } from '../../system/trpc'
import { format } from 'date-fns'
import { processTRPCData } from '../../Queries/fetchData'

export default observer(({ id }) => {
    const report =
        ReportCollection.reportsById[id] ||
        SessionStore.organisation.defaultStaffReport
    return (
        <RenderOnQueries
            key={'staff-table' + report.queryKey}
            loading={<LoadingSpinner />}
            queryIds={[
                {
                    id: 'staffReport' + report.queryKey,
                    cacheTime: 0,
                    staleTime: 0,
                    queryFn: async () => {
                        const data =
                            await trpc.staffReport.getReportsData.query({
                                columns: report.columns.filter(
                                    (c) =>
                                        !report.columnOptionsById[c]
                                            ?.permissions ||
                                        report.columnOptionsById[
                                            c
                                        ].permissions()
                                ),
                                filters: report.filters.map((f) => {
                                    if (
                                        report.columnOptionsById[f.column]
                                            ?.type === 'date'
                                    ) {
                                        let value =
                                            dateStringLookup[f.value]?.() ||
                                            f.value
                                        if (Array.isArray(value)) {
                                            value = value.map((d) =>
                                                d
                                                    ? format(d, 'yyyy-MM-dd')
                                                    : null
                                            )
                                        } else {
                                            value = value
                                                ? format(value, 'yyyy-MM-dd')
                                                : null
                                        }
                                        return {
                                            ...f,
                                            value,
                                        }
                                    } else {
                                        return f
                                    }
                                }),
                                groupBy: [],
                                sortBy: report.sortBy || [],
                                dateRange: report.dateRange.map((d) =>
                                    isFinite(d) ? format(d, 'yyyy-MM-dd') : null
                                ),
                                invoiceDateType:
                                    SessionStore.settings.reportInvoiceDateType,
                            })
                        return processTRPCData(
                            data,
                            'staffReport' + report.queryKey
                        )
                    },
                },
            ]}
        >
            <UpdateReportModal report={report} />
            {!report?.needsUpdate ? (
                <Table
                    tableStore={report.tableStore}
                    columns={report.tableColumns}
                    rows={FetchStore.getResponse(
                        'staffReport' + report.queryKey
                    )
                        ?.map((staff) => {
                            delete staff.id
                            return staff
                        })
                        ?.filter((staff) =>
                            staff.name
                                .toLowerCase()
                                .includes(report.searchFilter.toLowerCase())
                        )}
                    sortBy={report.sortBy}
                    showTotals={true}
                    // filters={report.filters}
                />
            ) : null}
        </RenderOnQueries>
    )
})
